import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciBadgesComponent } from './luci-badges.component';



@NgModule({
  declarations: [LuciBadgesComponent],
  exports: [LuciBadgesComponent],
  imports: [
    CommonModule
  ]
})
export class LuciBadgesModule { }
